import React, { Component } from 'react';
import PropTypes from 'prop-types';


import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';

import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Chip from '@mui/material/Chip';
import List from '@mui/icons-material/List';
import Done from '@mui/icons-material/CheckCircleOutline';
import Cancel from '@mui/icons-material/HighlightOff';

import { formatDate,formatStatus } from '../renderers';
import {bizpost} from '../../ajax';
import { Box, Button, Typography } from '@mui/material';
import MultiSelectGrid from '../grid/MultiSelectGrid';

const s:any = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: 'spacing(1)',
    marginRight: 'spacing(1)',
  },
  button: {
    marginBottom: 30,
    marginRight: -30,
  },
  title: {
    backgroundColor: 'grey.shade300',
  },
  valueChip: {
    // position: 'absolute',
    // right: 'spacing(12)',
  },
  cancelButton: {
    // position: 'absolute',
    // right: 'spacing(6)',
    // top: 'spacing(1)',
  },
  closeButton: {
    // position: 'absolute',
    // right: 'spacing(1)',
    // top: 'spacing(1)',
  },
  hide:{
    display:'none',
  },
};

class FMultiSelect extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    const {options,value} = props;
    const {conf} = options||{};
    const {recField='rid',keyField='rid',accessField='nam'} = conf||{};
    
    let questions = props.value && value.length>0 ? value.split(',') : [];
    this.state = {
      recField,
      keyField,
      accessField,
      next: true,
      data: props.data||[],
      open: false,
      svalue: null,
      value,
      //mask,
      questions
    };
  }

  componentDidMount(){
    const {value,options} = this.props;
    //if(!(value>=0)) return;
    const {params} = options;
    this.refresh(params);
  }

  refresh = async(params:any) => {
    try{
      this.startLoading();
      const response = await bizpost(params);
      const data = response.sd;
      this.setState({data,recordCount:+response.rc});
    }
    catch(error){
      this.setState({data:[],recordCount:0});
      const err:any = typeof error === 'object'?error : {};
      if(this.props.showNotification)
        this.props.showNotification(err.message||"request failed",err.type||'warn',err.title||'Loading Error'); 
    }
    finally{
      if (this.state.loading) this.stopLoading();
    }
  }

  startLoading = () => {
    this.setState({loading:true});
  }

  stopLoading = () => {
    this.setState({loading:false});
  }

  setBit = (val:number,bit:number) => {
    return (val |= (1 << bit));
  }

  unsetBit = (val:number,bit:number) => {
    return (val &= ~(1 << bit));
  }

  toggleBit = (val:Array<any>,rec:number) => {
    return val.includes(rec)?
      val.filter((v:any)=>v!==rec):
      [...val,rec];
  }

  setValid = (data:any) => {
    const valid = (!!data.ati);
    this.props.setValid(valid);
  }

  onChange = (name:any) => (value:any,m:any) => {
    const {data} = this.props;
    const newdata = {...data.data,[name]:value}; //newval
    this.setValid(newdata);
    this.props.setItem('data','data',newdata);
  }

  onSwitch = (rec:any) => (event:any) => {
      if(event.target){
        const {questions} = this.state;
        const {keyField} = this.state;
        const record = rec[keyField];
        const newquestions = this.toggleBit(questions,record);
        this.setState({questions:newquestions});
      }
      else console.log('event ',event);
  }

  onOpen = (event?:any) => {
    this.setState({open:true});
  }

  onClose = (event?:any) => {
    this.setState({open:false});
  }

  onCancel = (event?:any) => {
    this.setState({open:false});
  }

  onUpdate = (event?:any) => {
    const {questions} = this.state;
    //const newValue = questions.join(',');
    this.setState({open:false,value:questions});
    var items = {questions};
    var itemsToJSON = JSON.stringify(items);
    const {value,onChange} = this.props;
    if(typeof onChange === 'function' && value !== questions) onChange(itemsToJSON);
  }

  onFieldChange = (event?:any) => {
    const {onChange} = this.props;
    let value = event.target.value;
    this.setState({value});
    if(typeof onChange === 'function') onChange(value);
  };

  onMouseDown = (event:any) => {
    event.preventDefault();
  };

  defaultGridCfg = () => {
    const {recordCount} = this.state;
    const pages = (recordCount>5)?10:5;
    const [page,rowsPerPage,order,orderBy] = [0,pages,'asc','rid'];
    const [recField,keyField,accessField] = ['rid','rid','nam'];
    const grid = [['itc','Group'],['nam','Questions']];
    const rownum = true; //numbered list
    var init = rownum?[{id:'id',numeric:false,disablePadding:true,label:'No'}]:[];
    const cols = grid.reduce((ac,va)=>{
      ac.push({id:va[0],numeric:false,disablePadding:true,label:va[1]});
      return ac;
    },init);
    const formatters = {sts:formatStatus};
    const filter = (cols:any) => cols;

    return {recField,keyField,accessField,cols,rowsPerPage,page,order,orderBy,formatters,filter};
  }

  render() {
    const {id,label,divider,classes,...others } = this.props;
    const {value,questions,data,open} = this.state;
    const {recField,keyField,accessField} = this.state;
    const {options} = this.props;
    const {gridcfg} = options;

    const defconf = this.defaultGridCfg();
    const optconf = (typeof gridcfg === 'object')?gridcfg:{recField,keyField,accessField};
    const gridconf = {...defconf,...optconf}
    const {cols,rowsPerPage,page,order,orderBy,formatters,filter} = gridconf;

    //const bin = mask>=0?(mask >>> 0).toString(2):`${mask} invalid`;

    return (
      <Box sx={{...s.root}}>
        <Dialog onClose={this.onClose} aria-labelledby="simple-dialog-title" open={open}>
          <DialogTitle id="simple-dialog-title" sx={{...s.title}}>
            <Box sx={{display:'flex',justifyContent:'space-between',width:'100%'}}>
              {label}
              <IconButton color={"default"} aria-label="Cancel" sx={{...s.cancelButton}} onClick={this.onCancel}><Cancel/></IconButton>
            
            </Box>
          </DialogTitle>
          <Box sx={{marginTop:2,marginLeft:2,gap:2,display:'flex',flexWrap:'wrap',alignItems:'center'}}>
            {
              questions.length>0?
              questions.map((rec:any)=>(<Chip key={rec} variant="outlined" color="primary" size="small" sx={{...s.valueChip}} label={rec}/>))
              :
              <Chip variant="outlined" color="secondary" size="small" sx={{...s.valueChip}} label={"No selection"}/>  
            }
            {/* <Chip variant="outlined" color="primary" size="small" sx={{...s.valueChip}} label={bin}/> */}
            {
              questions.length>0?
              <Button variant='contained' color={"primary"} aria-label="Close" sx={{...s.closeButton}} onClick={this.onUpdate}><Typography>Confirm</Typography></Button>
              :
              null  
            }
          </Box>
          <MultiSelectGrid
            recField={recField}
            keyField={keyField}
            questions={questions}
            cols={cols}
            recordset={data}
            rowsPerPage={rowsPerPage}
            page={page}
            order={order}
            orderBy={orderBy}
            formatters={formatters}
            filterColumns={filter}
            onSwitch={this.onSwitch}
            {...others}
          />
        </Dialog>
        {/* <TextField
            label={label}
            id={id}
            name={id}
            type={'text'}
            margin='dense'
            fullWidth={true}
            sx={{...s.textField}}
            value={value}
            onChange={this.onFieldChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="open access control dialog"
                    onClick={this.onOpen}
                    onMouseDown={this.onMouseDown}
                    edge="end"
                    sx={{...s.button}}
                  >
                    <List color="secondary"/>
                  </IconButton>
              </InputAdornment>)
            }}
          /> */}
          
          <Button sx={{width:'100%',marginBottom:1,...s.butto}} variant="outlined" color="primary" onClick={this.onOpen}>
            <Typography>{value ? value : 'Select question'}</Typography>
          </Button>
        {divider && <Divider />}
      </Box>
    );
  }
}

FMultiSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default FMultiSelect;
